import {
    FETCH_TRAIT_FAILURE,
    FETCH_TRAIT_REQUEST,
    FETCH_TRAIT_SUCCESS
} from "./traitTypes"

const initialState = {
    loading: false,
    traits: [],
    error: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRAIT_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_TRAIT_SUCCESS:
            return {
                loading: false,
                traits: action.payload,
                error: '',
            }
        case FETCH_TRAIT_FAILURE:
            return {
                loading: false,
                traits: [],
                error: action.payload
            }
        default: return state;
    }
}
export default reducer;